import { Component, inject, Input, OnInit } from '@angular/core';
import { DxCircularGaugeModule } from 'devextreme-angular';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'ubt-measure-gauge',
  templateUrl: './measure-gauge.component.html',
  styleUrls: ['./measure-gauge.component.scss'],
  imports: [DxCircularGaugeModule],
})
export class MeasureGaugeComponent implements OnInit {
  constructor() {}
  protected readonly dataService = inject(DataService);

  ngOnInit() {}
  @Input() measureName: string;
  @Input() score: number;
  @Input() speed: number;
  @Input() benefit: number;

  customizeLabel = (e: { value: number; valueText: string }) => {
    if (e.value === 0) return '1';
    if (e.value === 36) return '36';
    return '';
  };
}
